import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Ertigaonrentinbelgaum() {



    const cardData = {




keyword: "Ertiga on Rent in Belgaum",

headingDescription: "Belgaum Taxi Service provides comfortable and affordable Ertiga on rent in Belgaum for family trips, corporate travel, airport transfers, wedding transportation, local sightseeing, railway station pickup, and outstation journeys. Maruti Ertiga is a popular choice for travelers who need spacious seating, better luggage capacity, smooth performance, and comfortable travel for small groups. Whether you require an Ertiga for a few hours, full-day rental, one-way trip, round-trip journey, or multi-day tour package, we offer well-maintained vehicles with experienced drivers. Our Ertiga rental service includes doorstep pickup, flexible booking options, transparent pricing, professional chauffeurs, and 24/7 customer support. Belgaum Taxi Service offers Ertiga rental facilities for travel across Karnataka, Maharashtra, Goa, and other nearby destinations, ensuring a safe, convenient, and comfortable journey for families, corporate groups, and tourists.",

topPlaces: [
  {
    title: "Belagavi Fort",
    description: "Belagavi Fort is a historic attraction located in the heart of the city, known for its ancient architecture, temples, and cultural importance. It is a popular destination for local sightseeing trips."
  },
  {
    title: "Kamal Basti",
    description: "Kamal Basti is an ancient Jain temple in Belgaum famous for its beautiful architecture and historical significance. It attracts visitors interested in heritage and religious tourism."
  },
  {
    title: "Gokak",
    description: "Gokak is known for the magnificent Gokak Falls, historic temples, and scenic landscapes. It is a popular short-distance destination from Belgaum for family outings."
  },
  {
    title: "Nipani",
    description: "Nipani is an important town near Belgaum known for trade, agriculture, and connectivity between Karnataka and Maharashtra. It is a frequent travel route for business and personal visits."
  },
  {
    title: "Sankeshwar",
    description: "Sankeshwar is a growing commercial town near Belgaum with industries, markets, and religious attractions, making it a common destination for comfortable cab travel."
  },
  {
    title: "Dandeli",
    description: "Dandeli is an adventure destination famous for wildlife, jungle safaris, river rafting, trekking, and nature experiences. Ertiga rental is suitable for families and groups visiting Dandeli."
  },
  {
    title: "Goa",
    description: "Goa is a popular holiday destination from Belgaum known for beaches, resorts, churches, water sports, and sightseeing attractions. Spacious Ertiga vehicles provide comfortable travel for groups."
  },
  {
    title: "Karwar",
    description: "Karwar is a beautiful coastal destination known for beaches, islands, temples, and scenic sea views. It is an ideal location for relaxed family trips."
  },
  {
    title: "Murudeshwar",
    description: "Murudeshwar is a famous coastal pilgrimage destination known for the Shiva statue, temple, beach, and Arabian Sea views. It is a popular long-distance travel destination from Belgaum."
  },
  {
    title: "Hampi",
    description: "Hampi is a UNESCO World Heritage Site famous for ancient ruins, temples, and historical monuments. It is a preferred destination for travelers planning heritage tours from Belgaum."
  }
],




"services": [
  {
    "name": "Ertiga Rent in Belgaum",
    "description": "Book Ertiga Rent in Belgaum for comfortable family trips, airport transfers, corporate travel, sightseeing, and outstation journeys with professional chauffeurs."
  },
  {
    "name": "Ertiga Rental Belgaum",
    "description": "Choose Ertiga Rental Belgaum with clean AC vehicles, experienced drivers, fixed pricing, and reliable transportation for every travel requirement."
  },
  {
    "name": "Maruti Ertiga on Rent Belgaum",
    "description": "Hire Maruti Ertiga on Rent Belgaum for group travel, family vacations, business trips, and comfortable long-distance journeys."
  },
  {
    "name": "Ertiga Cab Service Belgaum",
    "description": "Book Ertiga Cab Service Belgaum for local rides, airport transfers, one way trips, round trips, and outstation travel with dependable service."
  },
  {
    "name": "Ertiga Taxi Service Belgaum",
    "description": "Travel with Ertiga Taxi Service Belgaum offering affordable fares, spacious seating, professional drivers, and comfortable highway travel."
  },
  {
    "name": "Ertiga Cab Belgaum",
    "description": "Reserve Ertiga Cab Belgaum with flexible booking options, experienced chauffeurs, and well-maintained vehicles for every journey."
  },
  {
    "name": "Ertiga Taxi Belgaum",
    "description": "Choose Ertiga Taxi Belgaum for reliable airport pickups, family travel, corporate transportation, and outstation cab services."
  },
  {
    "name": "Online Ertiga Booking Belgaum",
    "description": "Complete Online Ertiga Booking Belgaum with instant confirmation, secure reservations, and 24x7 customer assistance."
  },
  {
    "name": "Ertiga Car Hire Belgaum",
    "description": "Book Ertiga Car Hire Belgaum for airport transfers, sightseeing, business meetings, and comfortable outstation travel."
  },
  {
    "name": "Ertiga for Outstation Belgaum",
    "description": "Reserve Ertiga for Outstation Belgaum with transparent pricing, experienced drivers, and comfortable intercity transportation."
  },
  {
    "name": "Ertiga Airport Transfer Belgaum",
    "description": "Book Ertiga Airport Transfer Belgaum with punctual pickup, flight tracking, luggage assistance, and reliable chauffeur service."
  },
  {
    "name": "Ertiga Airport Pickup Belgaum",
    "description": "Choose Ertiga Airport Pickup Belgaum for timely arrivals, comfortable seating, and hassle-free airport transportation."
  },
  {
    "name": "Ertiga Airport Drop Belgaum",
    "description": "Reserve Ertiga Airport Drop Belgaum with professional drivers, fixed fares, and comfortable airport transfer services."
  },
  {
    "name": "Ertiga One Way Cab Belgaum",
    "description": "Book Ertiga One Way Cab Belgaum for affordable direct travel with clean AC vehicles and experienced chauffeurs."
  },
  {
    "name": "Ertiga Round Trip Cab Belgaum",
    "description": "Hire Ertiga Round Trip Cab Belgaum with flexible return schedules, transparent pricing, and premium travel comfort."
  },
  {
    "name": "Ertiga Tour Package Belgaum",
    "description": "Choose Ertiga Tour Package Belgaum for family vacations, sightseeing tours, pilgrimage trips, and customized travel plans."
  },
  {
    "name": "Family Ertiga Cab Belgaum",
    "description": "Book Family Ertiga Cab Belgaum for spacious travel, comfortable seating, luggage capacity, and safe road trips."
  },
  {
    "name": "Corporate Ertiga Rental Belgaum",
    "description": "Reserve Corporate Ertiga Rental Belgaum for executive travel, office transportation, client visits, and business meetings."
  },
  {
    "name": "Wedding Ertiga Rental Belgaum",
    "description": "Hire Wedding Ertiga Rental Belgaum for guest transportation, family functions, ceremonies, and event travel."
  },
  {
    "name": "Best Ertiga Rental Belgaum",
    "description": "Choose the Best Ertiga Rental Belgaum with reliable service, experienced chauffeurs, fixed pricing, and premium comfort."
  },
  {
    "name": "Affordable Ertiga on Rent Belgaum",
    "description": "Book Affordable Ertiga on Rent Belgaum with budget-friendly fares, AC vehicles, and dependable outstation transportation."
  },
  {
    "name": "24/7 Ertiga Cab Service Belgaum",
    "description": "Reserve 24/7 Ertiga Cab Service Belgaum with round-the-clock availability, instant booking, and reliable chauffeur-driven travel."
  },
  {
    "name": "Ertiga Hire Near Me Belgaum",
    "description": "Find Ertiga Hire Near Me Belgaum with nearby pickup, quick confirmation, professional drivers, and comfortable travel."
  },
  {
    "name": "Private Ertiga Taxi Belgaum",
    "description": "Book Private Ertiga Taxi Belgaum for exclusive travel with complete privacy, flexible timings, and premium comfort."
  },
  {
    "name": "Premium Ertiga Cab Belgaum",
    "description": "Choose Premium Ertiga Cab Belgaum for business trips, airport transfers, family vacations, and luxury travel experience."
  },
  {
    "name": "Ertiga Taxi Booking Belgaum",
    "description": "Complete Ertiga Taxi Booking Belgaum online with secure reservations, multiple trip options, and transparent pricing."
  },
  {
    "name": "Belgaum to Goa Ertiga Cab",
    "description": "Book Belgaum to Goa Ertiga Cab with spacious seating, experienced drivers, and comfortable one way or round trip travel."
  },
  {
    "name": "Belgaum to Pune Ertiga Cab",
    "description": "Travel with Belgaum to Pune Ertiga Cab offering fixed fares, AC comfort, and reliable chauffeur-driven transportation."
  },
  {
    "name": "Belgaum to Mumbai Ertiga Cab",
    "description": "Reserve Belgaum to Mumbai Ertiga Cab for comfortable intercity travel with spacious luggage space and professional drivers."
  },
  {
    "name": "Belgaum to Bangalore Ertiga Cab",
    "description": "Choose Belgaum to Bangalore Ertiga Cab for safe, comfortable, and affordable long-distance travel."
  },
  {
    "name": "Belgaum to Hyderabad Ertiga Cab",
    "description": "Book Belgaum to Hyderabad Ertiga Cab with experienced chauffeurs, transparent pricing, and comfortable highway journeys."
  },
  {
    "name": "Belgaum to Kolhapur Ertiga Cab",
    "description": "Hire Belgaum to Kolhapur Ertiga Cab for family travel, business trips, and convenient one way or round trip service."
  },
  {
    "name": "Belgaum to Hubli Ertiga Cab",
    "description": "Reserve Belgaum to Hubli Ertiga Cab with reliable drivers, clean AC vehicles, and affordable fares."
  },
  {
    "name": "Belgaum to Mahabaleshwar Ertiga Cab",
    "description": "Book Belgaum to Mahabaleshwar Ertiga Cab for scenic road trips, holidays, and comfortable family travel."
  },
  {
    "name": "Belgaum to Shirdi Ertiga Cab",
    "description": "Travel with Belgaum to Shirdi Ertiga Cab offering safe pilgrimage journeys, spacious seating, and professional chauffeurs."
  },
  {
    "name": "Belgaum Outstation Ertiga Cab",
    "description": "Choose Belgaum Outstation Ertiga Cab for one way trips, round trips, airport transfers, and comfortable outstation travel with dependable service."
  }
],

"tableData": [
  ["Ertiga Rent in Belgaum", "Ertiga Rental Belgaum"],
  ["Maruti Ertiga on Rent Belgaum", "Ertiga Cab Service Belgaum"],
  ["Ertiga Taxi Service Belgaum", "Ertiga Cab Belgaum"],
  ["Ertiga Taxi Belgaum", "Online Ertiga Booking Belgaum"],
  ["Ertiga Car Hire Belgaum", "Ertiga for Outstation Belgaum"],
  ["Ertiga Airport Transfer Belgaum", "Ertiga Airport Pickup Belgaum"],
  ["Ertiga Airport Drop Belgaum", "Ertiga One Way Cab Belgaum"],
  ["Ertiga Round Trip Cab Belgaum", "Ertiga Tour Package Belgaum"],
  ["Family Ertiga Cab Belgaum", "Corporate Ertiga Rental Belgaum"],
  ["Wedding Ertiga Rental Belgaum", "Best Ertiga Rental Belgaum"],
  ["Affordable Ertiga on Rent Belgaum", "24/7 Ertiga Cab Service Belgaum"],
  ["Ertiga Hire Near Me Belgaum", "Private Ertiga Taxi Belgaum"],
  ["Premium Ertiga Cab Belgaum", "Ertiga Taxi Booking Belgaum"],
  ["Belgaum to Goa Ertiga Cab", "Belgaum to Pune Ertiga Cab"],
  ["Belgaum to Mumbai Ertiga Cab", "Belgaum to Bangalore Ertiga Cab"],
  ["Belgaum to Hyderabad Ertiga Cab", "Belgaum to Kolhapur Ertiga Cab"],
  ["Belgaum to Hubli Ertiga Cab", "Belgaum to Mahabaleshwar Ertiga Cab"],
  ["Belgaum to Shirdi Ertiga Cab", "Belgaum Outstation Ertiga Cab"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Ertiga on Rent in Belgaum",
    WhyChoosedescription: "Belgaum Taxi Service provides comfortable Maruti Ertiga rentals for local travel, airport transfers, corporate trips, family outings, and outstation journeys."
  },
  {
    WhyChooseheading: "Comfortable 7-Seater MPV",
    WhyChoosedescription: "The Maruti Ertiga offers spacious seating, excellent air conditioning, and ample luggage space, making it a perfect choice for families and small groups."
  },
  {
    WhyChooseheading: "Convenient Pickup Across Belgaum",
    WhyChoosedescription: "Book your Ertiga with doorstep pickup from Belgaum Airport, Railway Station, hotels, homes, offices, and nearby areas for a hassle-free journey."
  },
  {
    WhyChooseheading: "Experienced & Professional Drivers",
    WhyChoosedescription: "Our trained chauffeurs ensure safe driving, timely arrivals, and a pleasant travel experience on every trip."
  },
  {
    WhyChooseheading: "Suitable for Local & Outstation Trips",
    WhyChoosedescription: "Hire an Ertiga for city travel, airport transfers, weddings, sightseeing, business travel, and outstation destinations including Goa, Bangalore, Pune, Hubli, and Mumbai."
  },
  {
    WhyChooseheading: "Affordable Rental Packages",
    WhyChoosedescription: "Choose from one-way, round-trip, daily, and multi-day Ertiga rental plans with transparent pricing and no hidden charges."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "Every Ertiga is regularly serviced, sanitized, and inspected to provide a safe, reliable, and comfortable travel experience."
  },
  {
    WhyChooseheading: "24/7 Booking Assistance",
    WhyChoosedescription: "Reserve your Ertiga rental anytime with quick booking confirmation and dedicated customer support."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Ertiga on rent in Belgaum?",
    answer: "Yes, we offer Maruti Ertiga rentals for local travel, airport transfers, sightseeing, corporate travel, and outstation trips."
  },
  {
    question: "Can I book an Ertiga for one-way and round-trip travel?",
    answer: "Yes, both one-way and round-trip Ertiga rental services are available according to your travel requirements."
  },
  {
    question: "How many passengers can the Ertiga accommodate?",
    answer: "The Maruti Ertiga comfortably accommodates up to 6–7 passengers along with moderate luggage."
  },
  {
    question: "Do you provide Belgaum Airport pickup and drop?",
    answer: "Yes, Ertiga rentals are available for airport pickup and drop services to and from Belgaum Airport and Railway Station."
  },
  {
    question: "Can I hire an Ertiga for outstation travel?",
    answer: "Yes, we provide Ertiga rentals for destinations such as Goa, Bangalore, Hubli, Pune, Mumbai, Kerala, and many more."
  },
  {
    question: "Is the Ertiga suitable for family travel?",
    answer: "Yes, the spacious seating and comfortable interiors make the Ertiga an excellent choice for family vacations and group travel."
  },
  {
    question: "Are toll and parking charges included in the rental fare?",
    answer: "Toll charges, parking fees, state taxes, and other applicable charges are generally billed separately unless mentioned in the confirmed quotation."
  },
  {
    question: "Can I rent an Ertiga for corporate travel?",
    answer: "Yes, the Ertiga is a popular choice for business meetings, executive travel, airport transfers, and corporate employee transportation."
  },
  {
    question: "Is Ertiga rental available 24/7?",
    answer: "Yes, our Ertiga rental service operates 24 hours a day for local, airport, and outstation travel."
  },
  {
    question: "How can I book an Ertiga on Rent in Belgaum?",
    answer: "Share your pickup location, destination, travel date, passenger details, and preferred rental duration to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Santosh Patil",
    feedback: "The Ertiga was clean, spacious, and perfect for our family trip. The driver was punctual, polite, and made the journey comfortable from start to finish.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback: "We booked an Ertiga for an outstation journey and had an excellent experience. The vehicle was well-maintained, the booking was easy, and the overall service was outstanding.",
    rating: 5
  }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ertiga on Rent in Belgaum",
  "image": "https://www.belgaumtaxiservice.com/assets/images/ertiga-on-rent-in-belgaum.webp",
  "description":
    "Book Ertiga on Rent in Belgaum with Belgaum Taxi Service for comfortable and affordable taxi rental services. We provide Maruti Ertiga rentals for outstation trips, airport transfers, family travel, corporate journeys, and local travel with professional drivers available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/ertiga-on-rent-in-belgaum"
  }
};





    return (
        <div>

<Helmet>
  <title>Ertiga on Rent in Belgaum | Ertiga Cab Booking | +91 8722158435</title>

  <meta
    name="description"
    content="Book Ertiga on Rent in Belgaum with Belgaum Taxi Service for reliable and affordable Maruti Ertiga rental services. Hire Ertiga for outstation travel, airport transfers, family trips, corporate travel, and local journeys with professional drivers available 24x7."
  />

  <meta
    name="keywords"
    content="Ertiga Rent in Belgaum, Ertiga Rental Belgaum, Maruti Ertiga on Rent Belgaum, Ertiga Cab Service Belgaum, Ertiga Taxi Service Belgaum, Ertiga Cab Belgaum, Ertiga Taxi Belgaum, Online Ertiga Booking Belgaum, Ertiga Car Hire Belgaum, Ertiga for Outstation Belgaum, Ertiga Airport Transfer Belgaum, Ertiga Airport Pickup Belgaum, Ertiga Airport Taxi Belgaum"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>







            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/14.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Ertigaonrentinbelgaum;